import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { NarrativeSection } from './components/NarrativeSection';
import { LawsSection } from './components/LawsSection';
import { ProductReveal } from './components/ProductReveal';
import { OfferSection } from './components/OfferSection';
import { FloatingCTA } from './components/FloatingCTA';
import { FooterLegal } from './components/FooterLegal';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    f.fbq('init', '855275007473565');
    f.fbq('track', 'PageView');
  }, []);
  return <main className="bg-[#050505] min-h-screen w-full selection:bg-[#d4af37] selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <NarrativeSection data-id="element-2" />
      <LawsSection data-id="element-3" />
      <ProductReveal data-id="element-4" />
      <OfferSection data-id="element-5" />
      <FloatingCTA data-id="element-6" />
      <FooterLegal data-id="element-7" />
    </main>;
}